module.exports = __webpack_public_path__ + "static/media/img_penarikandiproses.b40e4035.svg";